import api from '../utils/api';

class ReportApi {
  getRevenue = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/revenue', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getRevenueTotal = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/revenue/total', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSales = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/sales', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getCashierOverview = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/cashier/overview', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getCashierReport = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/cashier/report', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getCashierReportCustomers = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('v1/report/cashier/report/customers', {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getCashierReportDetail = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/cashier/report/detail/' + id, {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  exportDataCloseSellingPdf = (id, close_selling_id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .post(
          `/v1/report/cashier/report/detail/export-pdf/${id}/${close_selling_id}`,
          {
            params: data,
          },
          {
            responseType: 'blob', // Yêu cầu phản hồi kiểu blob (dữ liệu nhị phân)
          }
        )
        .then((response) => {
          // Tạo một đường dẫn đến tệp dữ liệu
          const url = window.URL.createObjectURL(new Blob([response.data]));

          // Tạo một thẻ a ẩn và sử dụng nó để kích hoạt tải xuống
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute(
            'download',
            `close_selling_${new Date().toISOString()}.pdf`
          );
          document.body.appendChild(link);
          link.click();
          resolve(response.data);
        })

        .catch((error) => {
          reject(error);
        });
    });
  };

  getAllFund = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/report/bill/fund', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllDebtConfirm = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/report/order/list', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSendEmail = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/report/order/sendEmail', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/route/findAll', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  getAllRoutes = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/get-routes', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDestinations = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/report/dest/' + id, { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getPassengerByRouteId = (id, date) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(
          `/reports/route/passenger/${id}?date=${date}`
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  exportDataExcel = async (id, date) => {
    try {
      const res = await api.get(
        `/reports/passenger/export-excel/${id}?date=${date}`,
        {
          responseType: 'blob', // Quan trọng để xử lý file Excel
        }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  };

  exportDataPdf = (id, date) => {
    return new Promise((resolve, reject) => {
      return api
        .get(`/reports/passenger/export-pdf/${id}?date=${date}`, {
          responseType: 'blob', // Yêu cầu phản hồi kiểu blob (dữ liệu nhị phân)
        })
        .then((response) => {
          // Tạo một đường dẫn đến tệp dữ liệu
          const url = window.URL.createObjectURL(new Blob([response.data]));

          // Tạo một thẻ a ẩn và sử dụng nó để kích hoạt tải xuống
          const link = document.createElement('a');
          link.href = url;

          link.setAttribute('download', `passengers_${date}.pdf`);
          document.body.appendChild(link);
          link.click();
          resolve(response.data);
        })

        .catch((error) => {
          reject(error);
        });
    });
  };
}
const reportApi = new ReportApi();
export default reportApi;
